/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-useless-escape */
import CryptoJS from "crypto-js";
import moment from "moment/moment"
import { show_error_swal_ok_admin } from "./SwalService";
import { validate } from 'uuid';

const ADMIN_TOKEN_KEY = 'ff591090-0805-4282-8493-e9435a4d3d67';
const AUTH_STORAGE_KEY = 'a3f7b2c1-9d4e-4a8f-b6c5-2e1d0f9a8b7c';
const long_date_api_format_moment = 'YYYY-MM-DD HH:mm:ss';

const role = {
    "super-admin": 1,
    "Admin": 2,
    "Authorizer": 3,
    "Checker": 4,
    "Operations_Admin": 5,
}

const residential_status_list = [
    { value: '01', label: 'Resident Individual' },
    { value: '02', label: 'Non Resident Indian' },
    { value: '03', label: 'Foreign National' },
    { value: '04', label: 'Person of Indian Origin' },
]
const residential_status_legeal_list = [
    { value: '01', label: 'Resident/Business' },
    { value: '02', label: 'Residential' },
    { value: '03', label: 'Business' },
    { value: '04', label: 'Registered Office' },
    { value: '05', label: 'Unspecified' }
]

const card_records = {
    "closed-records": { ckycstateid: [8, 9], ckybsubstatusid: [], ckycstageid: [], link_url: '/closed-record', heading: 'Closed Records' },
    "image-not-uploaded-records": { ckycstateid: [], ckybsubstatusid: [5], ckycstageid: [], link_url: '/image-not-uploaded-record', heading: 'Image Not Found Records' },
    "data-valid-records": { ckycstateid: [], ckybsubstatusid: [1], ckycstageid: [], link_url: '/data-valid-record', heading: 'Data Valid Records' },
    "confirm-match-records": { ckycstateid: [], ckybsubstatusid: [24], ckycstageid: [], link_url: '/confirm-match-record', heading: 'Confirm Match Records' },
    "search-failed-records": { ckycstateid: [], ckybsubstatusid: [13], ckycstageid: [], link_url: '/search-failed-record', heading: 'Search Failed Records' },
    "download-failed-records": { ckycstateid: [], ckybsubstatusid: [15], ckycstageid: [], link_url: '/download-failed-record', heading: 'Download Failed Records' },
    "in-process-records": { ckycstateid: [5], ckybsubstatusid: [], ckycstageid: [], link_url: '/in-process-record', heading: 'In-Process Records' },
    "error-records": { ckycstateid: [7], ckybsubstatusid: [], ckycstageid: [], link_url: '/error-record', heading: 'Error Records' },
    "res0-failed-records": { ckycstateid: [7], ckybsubstatusid: [20], ckycstageid: [], link_url: '/res0-failed-record', heading: 'RES0 Failed Records' },
    "res1-failed-records": { ckycstateid: [], ckybsubstatusid: [21], ckycstageid: [], link_url: '/res1-failed-record', heading: 'RES1 Failed Records' },
    "authorizer-rejected-records": { ckycstateid: [6], ckybsubstatusid: [], ckycstageid: [], link_url: '/authorizer-rejected-record', heading: 'Authorizer Rejected Records' },
}

const set_admin_logged = (data) => {
    const temp = JSON.stringify(data);
    let enc = encrypt(temp);
    localStorage.setItem(ADMIN_TOKEN_KEY, enc);
    return enc
};

const admin_logged_data = () => {
    const session_data = localStorage.getItem(ADMIN_TOKEN_KEY);
    const decrypted = session_data?.length > 0 ? decrypt(session_data) : null;
    const data = decrypted?.length > 0 ? JSON.parse(decrypted) : null;
    return data?.access_token?.length > 0 ? data : null;
};

const admin_logged_clear = () => {
    localStorage.setItem(ADMIN_TOKEN_KEY, '');
    localStorage.removeItem(ADMIN_TOKEN_KEY);
};

const has_admin_permission = (PageId) => {
    if (!PageId) {
        return false
    }
    let tmp = admin_logged_data();
    if (tmp !== null) {
        for (let i = 0; i < tmp?.permissions?.length; i++) {
            if (tmp?.permissions[i]?.id?.toString() === PageId?.toString()) {
                return tmp?.permissions[i]?.status;
            }
        }
    }
    return false;
};

const generateRandAlphaNumStr = (len) => {
    let rdmString = '';
    for (
        ;
        rdmString.length < len;
        // rdmString += Math.random().toString(36).substring(2)
        rdmString += secureRandomString(len)
    );
    return rdmString.substring(0, len);
};
function secureRandomString(length = 16) {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('');
}

const encrypt = (param) => {
    let key = generateRandAlphaNumStr(32);
    let iv = generateRandAlphaNumStr(16);
    let encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(param),
        CryptoJS.enc.Utf8.parse(key),
        {
            keySize: 128 / 8,
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );
    return btoa(key + iv + encrypted.toString());
};

const decrypt = (param) => {
    try {
        param = atob(param);
        param = param.replace(' ', '+');
        let key = CryptoJS.enc.Utf8.parse(param.substring(0, 32));
        let iv = CryptoJS.enc.Utf8.parse(param.substring(32, 32 + 16));
        let encryptedText = param.substring(32 + 16);
        let decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch {
        return '';
    }
};

const DateFormat = (datetxt) => {
    return datetxt ? moment(datetxt, long_date_api_format_moment).format('DD MMM YYYY, hh:mm A') : '';
};

const DateFormatLongDDMMYYYY = (datetxt) => {
    return datetxt ? moment(datetxt, `DD-MM-YYYY HH:mm:ss`).format('DD MMM YYYY, hh:mm A') : '';
};

const characterOnly = (inputText) => {
    if (inputText) {
        let patt = /^[A-Za-z]+$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};
const character_dash = (inputText) => {
    if (inputText) {
        if (inputText[inputText.length - 1] === ' ') {
            return true;
        }
        let patt = /^[_A-Za-z]+([-\s][_A-Za-z]+)*$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};
const entity_name_chars = (inputText) => {
    if (inputText) {
        if (inputText[inputText.length - 1] === ' ') {
            return true;
        }
        let patt = /^[A-Za-z0-9\s&.,\-'()]+$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};

const characterWithSpace = (inputText) => {
    if (inputText) {
        let patt = /^[A-Za-z ]+$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};

const numericOnly = (inputText) => {
    if (inputText) {
        let patt = /^\d*$/
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};
const alphaNumericOnly = (inputText) => {
    if (inputText) {
        let patt = /^[a-zA-Z0-9]+$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};

const alphaNumericDash = (inputText) => {
    if (inputText) {
        let patt = /^[a-zA-Z0-9-]+$/;
        let result = patt.test(inputText);
        return result;
    } else {
        return true;
    }
};

const numeric_dec_Only = (inputText) => {
    if (inputText) {
        if (inputText.split(".").length > 2) {
            return false;
        }
        let afetrDec = inputText.split(".")[1];
        if (afetrDec?.length > 2) {
            return false
        }
        let patt = /^[0-9.]*$/;
        let result = patt.test(inputText.replaceAll(',', '').toString());
        return result;
    } else {
        return true;
    }
};

const check_in_array = (e, list) => {
    for (let i = 0; i < list?.length; i++) {
        if (list[i]?.toString()?.toLowerCase()?.trim() === e?.toString()?.toLowerCase()?.trim()) {
            return true;
        }
    }
    return false;
};
const check_common_in_array = (array1, array2) => {
    const set1 = new Set(array1);
    const hasCommonElements = array2.some(item => set1.has(item));
    return hasCommonElements
}


const getFilename = (filename) => {
    if (filename.startsWith("filename*=")) {
        return decodeURIComponent(filename.replace("filename*=", "").split("''").slice(1).join("''"));
    } else if (filename.startsWith("filename=")) {
        return filename.replace(/^filename=(")?(.*)\1$/, "$2");
    }
    return filename;
};

const file_name_from_content_disposition = (disposition) => {
    if (!disposition || !(disposition.startsWith('attachment') || disposition.startsWith('inline'))) {
        return null;
    }

    let filename = disposition.startsWith('attachment')
        ? disposition.replace("attachment;", "")
        : disposition.replace("inline;", "");

    filename = filename.trim();

    if (filename.includes("filename*=") || filename.includes("filename=")) {
        const filenames = filename.split(";").map(f => f.trim());
        filename = filenames.find(f => f.startsWith("filename*=")) || filenames.find(f => f.startsWith("filename="));
    }

    return filename ? getFilename(filename) : null;
};


const reverseDate = (date) => {
    if (date && date.length > 0) {
        let _date = date.split('-').reverse().join('-');
        return _date
    }
    return ''
};
const colur_code = {
    1: '#ff6516', //orange
    2: '#ffc107', //orange
    3: "#008062", // green
    4: "#1fb259", // light-green
    5: "#B23C52" //red
}
const getStatusHtml = (data) => {
    const getLabelAndColor = (id, statusArray) => {
        const statusItem = statusArray.find(item => id.toString() === item.id.toString());
        return statusItem ? { label: statusItem.label, color: statusItem.color_code } : null;
    };

    const renderStatusHtml = (label, color, statusType) => {
        return `<div class="mb-1">
            <span class="btn btn-status px-2" style="background-color:${colur_code[color]}"> ${" "}${statusType} : <span>${label}</span></span>
        </div>`;
    };

    const ckycstateid = Math.max(0, Number(data.form_data.ckycstateid) || 0);
    const ckycstageid = Math.max(0, Number(data.form_data.ckycstageid) || 0);
    const ckybsubstatusid = Math.max(0, Number(data.form_data.ckybsubstatusid) || 0);

    let _html = '';

    if (ckycstateid > 0) {
        const state = getLabelAndColor(ckycstateid, data.ckyc_status_master.state);
        if (state) {
            _html += renderStatusHtml(state.label, state.color, "State");
        }
    }

    if (ckycstageid > 0) {
        const stage = getLabelAndColor(ckycstageid, data.ckyc_status_master.stage);
        if (stage) {
            _html += renderStatusHtml(stage.label, stage.color, "Stage");
        }
    }

    if (ckybsubstatusid > 0) {
        const status = getLabelAndColor(ckybsubstatusid, data.ckyc_status_master.status);
        if (status) {
            _html += renderStatusHtml(status.label, status.color, "Status");
        }
    }

    return _html;
};

const fileSizeUnits = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const bytes_to_readable = (x) => {
    let l = 0, n = Number.parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
        n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + fileSizeUnits[l]);
};
const checkFileSizeAndType = (selectedFile, size, allowed_extension) => {
    // size pass is in KB 
    if (size > 0 && (selectedFile.size / 1024) >= size) {
        show_error_swal_ok_admin("File size limit exceeded.<br>Maximum allowed size is " + bytes_to_readable(size * 1024) + ".");
        return false;
    }
    let ext = selectedFile.name.substr(selectedFile.name.lastIndexOf('.')).toLocaleLowerCase();
    let is_valid_type = false;
    for (const extension of allowed_extension) {
        if (extension.toLocaleLowerCase() === ext) {
            is_valid_type = true;
            break;
        }
    }
    if (!is_valid_type) {
        show_error_swal_ok_admin('Invalid file type.<br/>Please upload a file in<br/>' + allowed_extension.join(', ') + " format.");
        return false;
    }
    return true;

}

const is_permission_on_page = (page_details = {}, role = []) => {
    const matchingRoles = page_details.filter(item => role.includes(item.role));
    if (matchingRoles?.length <= 0) {
        let roles = ['super-admin', 'admin', 'maker', 'checker', 'authorizer']
        const setArray2 = new Set(roles);
        const commonRole = role.filter(element => setArray2.has(element));
        if (commonRole.length > 0) {
            switch (commonRole[0]) {
                case 'super-admin':
                    return '/dashboard';
                case 'admin':
                    return '/dashboard';
                case 'maker':
                    return '/data-upload-records';
                case 'checker':
                    return '/cheker-review';
                case 'authorizer':
                    return '/authorizer-review';
                default:
                    return '/dashboard';
            }
        }
    }
    return ''
}
const trimOnBlur = (formik, filed) => {
    let val = formik.values[filed]?.replaceAll(/\s{2,}/g, ' ');
    formik.setFieldValue(filed, val.trim());
}

const checkInDropdwonValue = (arr, value, parameter = false) => {
    if (parameter) {
        for (const item of arr) {
            if (item[parameter]?.toString() === value?.toString()) {
                return value;
            }
        }
    } else {
        for (const item of arr) {
            if (item?.toString() === value?.toString()) {
                return value;
            }
        }
    }
    return ''
}
function isUUID(str) {
    if (str != null && str.length > 0) {
        return validate(str)
    }
    return false;
}
const getRecordTypeName = (id, entityList) => {
    if (entityList?.length > 0) {
        for (const entity of entityList) {
            if (entity?.id?.toString() === id?.toString()) {
                return entity?.label_name;
            }
        }
    }
    return '';
}

const getKeyForTable = (keyLabel, index) => {
    return keyLabel + '_' + index
}
function get_txt(val) {
    return val || '';
}

function get_bool(val) {
    return val || false;
}

function tryParseInt(v) {
    try { if (v) { return (Number.parseInt(v) || 0); } } catch (error_) { console.warn(error_); }
    return 0;
}

function addTrailingSlashIfMissing(url) {
    return url?.endsWith('/') ? url?.trim() : `${url?.trim()}/`;
}

// Decode JWT token without library
const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
};

const character_dash_apostrophe = (inputText) => {
    if (!inputText) {
        return true;
    }

    // Must start with a letter
    if (!/^[A-Za-z]/.test(inputText)) {
        return false;
    }

    // Allow if ends with space (user typing next word)
    if (inputText.endsWith(' ')) {
        return true;
    }

    // Split into words by space or hyphen
    const words = inputText.split(/[\s-]/).filter(word => word.length > 0);

    return words.every((word, index) => validateWord(word, index === words.length - 1));
};

const validateWord = (word, isLastWord) => {
    const apostropheCount = (word.match(/'/g) || []).length;

    // More than one apostrophe in a word is not allowed
    if (apostropheCount > 1) {
        return false;
    }

    // Last word ends with apostrophe - user is still typing
    if (isLastWord && word.endsWith("'")) {
        return /^[A-Za-z]+$/.test(word.slice(0, -1));
    }

    // Word with one apostrophe: must be letters + apostrophe + letters
    if (apostropheCount === 1) {
        return /^[A-Za-z]+'[A-Za-z]+$/.test(word);
    }

    // No apostrophe - just letters
    return /^[A-Za-z]+$/.test(word);
};

let config = {};

export const loadConfig = async () => {
    let res;
    try {
        res = await fetch('/config.json');
    } catch {
        throw new Error(`<br/>Failed to load config.json.
            <br/>Please ensure config.json exists on frontend server.
            <br/><br/>If you are running locally, create a config.json file
            <br/>in the public folder with the following content:
            <br/><pre>{ "API_BASE_URL": "backend_api_base_url_should_be_here" }</pre>`);
    }
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
        throw new Error(`<br/>Failed to load config.json.
            <br/>Please ensure config.json exists on frontend server.
            <br/><br/>If you are running locally, create a config.json file
            <br/>in the public folder with the following content:
            <br/><pre>{ "API_BASE_URL": "backend_api_base_url_should_be_here" }</pre>`);
    }
    try {
        config = await res.json();
    } catch {
        throw new Error('<br/>config.json contains invalid JSON. Please check the file format.');
    }
    if (!config.API_BASE_URL) {
        throw new Error('<br/>API_BASE_URL is missing in config.json.<br/>Please add API_BASE_URL to config.json.');
    }
};

function getApiBaseUrl() {
    return addTrailingSlashIfMissing(config.API_BASE_URL || '');
}

export {
    AUTH_STORAGE_KEY,
    residential_status_list,
    residential_status_legeal_list,
    tryParseInt,
    get_txt,
    get_bool,
    check_common_in_array,
    card_records,
    role,
    checkInDropdwonValue,
    is_permission_on_page,
    trimOnBlur,
    character_dash,
    entity_name_chars,
    checkFileSizeAndType,
    reverseDate,
    set_admin_logged,
    admin_logged_data,
    admin_logged_clear,
    has_admin_permission,
    encrypt,
    decrypt,
    DateFormat,
    DateFormatLongDDMMYYYY,
    characterOnly,
    characterWithSpace,
    numericOnly,
    alphaNumericOnly,
    alphaNumericDash,
    numeric_dec_Only,
    check_in_array,
    file_name_from_content_disposition,
    getStatusHtml,
    isUUID,
    getRecordTypeName,
    getKeyForTable,
    addTrailingSlashIfMissing,
    decodeToken,
    character_dash_apostrophe,
    getApiBaseUrl,
};